import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppService } from '@app/services/app/app.service';

import { MenuItem,WorkflowMenuItem } from '@core/models/menu-item.model';

import * as Objects from '@core/objects';
import { workflowsMenu,workflowsDefaultItem } from './workflows.menu';
import { DashboardService } from 'app/services/app/dashboard.service';


@Component({
    selector: 'dashboard-workflows-menu-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class DashboardWorkflowsMenuMainComponent implements OnInit, OnDestroy {
    @Input() workflows: Objects.Workflow[];
    @Input() view: string;
    
    public dashboardMenu: WorkflowMenuItem[] = workflowsMenu;
    public match: boolean = false; // to not match full uls on vetrical tabs

    public workflowsCounter: Array<Objects.WorkflowRequestsCounter> = null;

    protected counterSubscriber: Subscription;

	constructor(
        public appSrv: AppService,
        private dashSrv: DashboardService
    ){}

	ngOnInit(){

        this.counterSubscriber = this.dashSrv.selectCurrentWorkflowCounter().subscribe((wfc : Objects.WorkflowRequestsCounter[]) => {
            this.workflowsCounter = wfc;
            this.updateMenu();
        })
        if(this.workflows)
            this.updateMenu()
    }

    ngOnDestroy(): void {
        this.counterSubscriber.unsubscribe();
    }

    // not used
    onMenuClick(item: WorkflowMenuItem ){
        // console.log(" LISTEN TO NEW WORKFLOW =====> ",item);

        // TODO: what should do HERE ???
        // this.dashSrv.setCurrentWorkflow(+item.workflow);
    }

    protected updateMenu(){

        // set ordered workflows in left menu
        this.dashboardMenu = [...this.workflows].sort((a, b) => a.id - b.id).map((workflow: Objects.Workflow) => {
            let itemTitle: string = workflow.name;

            if (this.workflowsCounter != null ){
                const counter = this.workflowsCounter.filter((item) => item.workflow.id == workflow.id)[0]?.requests?.count;
                itemTitle += " ("+counter+")";
            }
            return {...workflowsDefaultItem, 
                        title: itemTitle,
                        link: workflowsDefaultItem.link.replace(':id', workflow.id.toString()+'/'+this.view),
                        workflow: workflow.id
                     }
        });
    }



}
